export default __webpack_public_path__ + "static/media/Notification-35.6540e4d1.png";